<template>
  <el-dialog
      :visible.sync="visible"
      title="费用调整"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <SweetTable :data="dataForm.detailList" :is-page="false" :height="500">
        <el-table-column label="订单编号" prop="orderCode" align="center" width="180" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="品番号" prop="product.code" align="center">
          <template #default="{row}">
            <ProductRowCard :product="row.product"></ProductRowCard>
          </template>
        </el-table-column>
        <el-table-column label="计划数" prop="planCount" align="center" width="100"></el-table-column>
        <el-table-column label="纸箱" prop="packPrice" align="center" width="160">
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.packPrice'"
                :rules="detailRule.packPrice"
                label-width="0"
            >
              <el-input v-model="scope.row.packPrice" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="中棉" prop="cottonPrice" align="center" width="160">
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.cottonPrice'"
                :rules="detailRule.cottonPrice"
                label-width="0"
            >
              <el-input v-model="scope.row.cottonPrice" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="运费" prop="freightPrice" align="center" width="160">
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.freightPrice'"
                :rules="detailRule.freightPrice"
                label-width="0"
            >
              <el-input v-model="scope.row.freightPrice" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button size="mini" @click="visible=false">{{ $t('cancel') }}</el-button>
      <el-button size="mini" type="primary" @click="dataFormSubmitHandle">确认修改</el-button>
    </template>
  </el-dialog>
</template>

<script>
/**
 * 成品发货弹窗
 */
import DictDropdown from '@/components/DictDropdown/index.vue'
import debounce from 'lodash/debounce'
import MultipleImageUpload from '@/components/MultipleImageUpload'
import { countValidator, moneyValidator } from '@/utils/validate'
import ProductRowCard from '@/components/ProductRowCard.vue'
import FactoryDrop from '@/views/modules/trade/common/FactoryDrop/index.vue'
import {batchCreateAudit} from '@/api/commonApi'
export default {
  components: { DictDropdown, FactoryDrop, ProductRowCard, MultipleImageUpload },
  data () {
    return {
      visible: false,
      dataForm: {},
      receiverList: [],
      company: { id: '', name: '' },
      factoryList: [],
      receiverType: 'factory',//收货方类型，harbour：港口，factory：工厂
    }
  },
  computed: {
    detailRule () {
      return {
        count: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
          {
            validator: countValidator,
            trigger: 'change',
          },
        ],
        packPrice: [
          {
            required: false,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
          {
            validator: moneyValidator,
            trigger: 'change',
          },
        ],
        cottonPrice: [
          {
            required: false,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
          {
            validator: moneyValidator,
            trigger: 'change',
          },
        ],freightPrice: [
          {
            required: false,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
          {
            validator: moneyValidator,
            trigger: 'change',
          },
        ],
      }
    },
    dataRule () {
      return {}
    }
  },
  methods: {
    init (detailList) {
      this.dataForm = {
        id: this.dataForm.id,
        remark: '',
        imgs: '',
        detailList: detailList,
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    async doSave(dataList){
      let loading = this.$loading()
      try{
        let res=await batchCreateAudit('加工单其他费用调整',dataList)
        this.$message.success('提交成功，请等待审核结果')
        this.visible = false
        this.$emit('change')
      }catch (e) {
        console.log(e)
      }finally {
        loading.close()
      }
    },
    // 表单提交
    dataFormSubmitHandle:
        debounce(
            function () {
              this.$refs['dataForm'].validate((valid) => {
                if (!valid) {
                  return false
                }
                let postForm = []
                this.dataForm.detailList.forEach((row) => {
                  postForm.push({
                    bisId: row.id,
                    params:{
                      packPrice: row.packPrice,
                      cottonPrice: row.cottonPrice,
                      freightPrice: row.freightPrice
                    }
                  })
                })
                if (postForm.length === 0) {
                  return this.$message.error('没有要保存的数据')
                }
               this.doSave(postForm)
              })
            },
            1000,
            { leading: true, trailing: false }
        )
  },
}
</script>

<style lang="scss" scoped>
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
